/**
 * Safely builds a reactor display name from optional first/last name parts.
 * Returns `undefined` (not the string `"undefined undefined"`) when both parts
 * are absent, so callers can apply `|| 'Unknown User'` reliably.
 * CR-B3-05.
 */
export const buildReactorName = (
  firstName?: string,
  lastName?: string,
): string | undefined =>
  [firstName, lastName].filter(Boolean).join(' ') || undefined;
